import { render, staticRenderFns } from "./IllustrationSearchEmptyResults.svg?vue&type=template&id=8e9b9a3a&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports